export default __webpack_public_path__ + "static/media/icon-right-arrow.7046cd1b.svg";